export default __webpack_public_path__ + "static/media/secondOne.30c9ad37.gif";